<template>
  <div class="view pa24">
    <div class="flex-a-c h40 bgf5f6 pl10">
      <p class="fs8 fwbold cA1 mr20">{{ getReferralModeText() }}</p>
      <el-switch
        v-model="state"
        class="mt3 mr20"
        active-color="#51CBCD"
        inactive-color="#C0CBCC">
      </el-switch>
      <p class="fs7 cA1">{{ getReferralModeDescriptionText() }}</p>
    </div>
    <div class="flex-a-c h40 pl10 mt10">
      <p class="fs8 fwbold cA1 mr20">{{ getReferralModeText() }}</p>
      <p class="fs7 cA1" v-html="getReferralModeNoteText()"></p>
    </div>
    <el-input
      class="pl10 mt10 w1000"
      type="textarea"
      :rows="4"
      :placeholder="getRulesPlaceholderText()"
      v-model="desc">
    </el-input>
    <div class="pl10 mt10 fs8 fwbold cA1">
      {{ getPromotionRewardSettingText() }}
    </div>
    <div class="flex-a-c pl10 mt10 fs7 cA1">
      {{ getPromotionRewardDescriptionText() }}
      <el-input
        class="w100"
        v-model="settlementDate"
        @blur="Blurtext($event)">
      </el-input>
      {{ getDaysAfterText() }}
      <el-input
        class="w100"
        v-model="rate"
        @blur="percentText($event)">
      </el-input>
             {{ getPromotionRewardPercentageText() }}
    </div>

    <div class="flex-a-c pl10 mt10 fs7 cA1">
            {{ getWithdrawalAmountSettingText() }}
      <el-input
        class="w100"
        v-model="cashAmount"
        @change="() => {
          cashAmount =  cashAmount < 0 ? '' : cashAmount
        }"
        >
      </el-input>
             {{ getWithdrawalAmountDescriptionText() }}
    </div>
    <!-- 关闭自动设置，现在只有人工付款 -->
    <!-- <div class="flex-a-c pl10 mt10 fs7 cA1">
            {{ getAutoWithdrawalSettingText() }}
      <el-switch
        v-model="autoArrive"
        class="mt3 mr20"
        active-color="#51CBCD"
        inactive-color="#C0CBCC">
      </el-switch>
      {{ getAutoWithdrawalDescriptionText() }}
    </div> -->
    <div class="flex-c-c mt40">
      <el-button type="primary" @click="saveSetting">{{ getSaveText() }}</el-button>
    </div>
    
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {  
  updateSetting,
  querySetting
 } from "@/api/turnToIntroduce";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "visitorData",
  components: {
    
  },
  data() {
    return {
      state:false,
      desc:'',
      settlementDate:0,
      rate:0,
      cashAmount:0,
      autoArrive:false,
    };
  },
  mounted(){
    this.querySetting();
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    saveSetting(){
      if(!this.desc && this.state){
        this.$message.error(this.getFillRulesErrorText())
        return
      }
      let data = {
        rate:this.rate / 100,
        autoArrive:this.autoArrive,
        settlementDate:this.settlementDate,
        cashAmount:this.cashAmount,
        state:this.state ? 1 : 0,
        desc:this.desc
      }
      updateSetting(data)
      .then(res=>{
        if(res.code == 200){
          this.$message.success(this.getSaveSuccessText())
        }
      })
    },
    querySetting(){
      let data = {
        ignore:true
      }
      querySetting(data)
      .then(res=>{
        console.log(res.data,111111)
        if(res.data){
        console.log(res.data,22222222)
        this.rate = res.data.rate * 100
        this.autoArrive = res.data.autoArrive
        this.settlementDate = res.data.settlementDate
        this.cashAmount = res.data.cashAmount
        this.state = res.data.state
        this.desc = res.data.desc
        }
      })
    },
    Blurtext(e){
      let boolean = new RegExp("^[0-9][0-9]*$").test(e.target.value)
      if(!boolean ){
        this.$message.warning(this.getPositiveIntegerErrorText())
        e.target.value = ''
      }else if(e.target.value > 999){
        this.$message.warning(this.getMaxDaysErrorText())
        e.target.value = ''
      }
    },
    percentText(e){
      if(e.target.value < 0 || e.target.value > 100){
        e.target.value = 0
      }else{
        e.target.value = (e.target.value*1).toFixed(2)
      }
    },
    
    // 多语言方法 - 使用i18n配置
    getReferralModeText() {
      return this.$t('referralRules', 'referralMode');
    },
    
    getReferralModeDescriptionText() {
      return this.$t('referralRules', 'referralModeDescription');
    },
    
    getReferralModeNoteText() {
      return this.$t('referralRules', 'referralModeNote');
    },
    
    getRulesPlaceholderText() {
      return this.$t('referralRules', 'rulesPlaceholder');
    },
    
    getPromotionRewardSettingText() {
      return this.$t('referralRules', 'promotionRewardSetting');
    },
    
    getPromotionRewardDescriptionText() {
      return this.$t('referralRules', 'promotionRewardDescription');
    },
    
    getDaysAfterText() {
      return this.$t('referralRules', 'daysAfter');
    },
    
    getPromotionRewardPercentageText() {
      return this.$t('referralRules', 'promotionRewardPercentage');
    },
    
    getWithdrawalAmountSettingText() {
      return this.$t('referralRules', 'withdrawalAmountSetting');
    },
    
    getWithdrawalAmountDescriptionText() {
      return this.$t('referralRules', 'withdrawalAmountDescription');
    },
    
    getAutoWithdrawalSettingText() {
      return this.$t('referralRules', 'autoWithdrawalSetting');
    },
    
    getAutoWithdrawalDescriptionText() {
      return this.$t('referralRules', 'autoWithdrawalDescription');
    },
    
    getSaveText() {
      return this.$t('referralRules', 'save');
    },
    
    getFillRulesErrorText() {
      return this.$t('referralRules', 'fillRulesError');
    },
    
    getSaveSuccessText() {
      return this.$t('referralRules', 'saveSuccess');
    },
    
    getPositiveIntegerErrorText() {
      return this.$t('referralRules', 'positiveIntegerError');
    },
    
    getMaxDaysErrorText() {
      return this.$t('referralRules', 'maxDaysError');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
